import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import SuperadminDashboard from './components/SuperadminDashboard';
import CompanyManagement from './components/CompanyManagement';
import AdminUserManagement from './components/AdminUserManagement';
import SubscriptionPlanManagement from './components/SubscriptionPlanManagement';
import CompanySubscriptionDetails from './components/CompanySubscriptionDetails';
import AdminDashboard from './components/AdminDashboard';
import ModuleSelection from './components/ModuleSelection';
import Dashboard from './components/Dashboard';
import ItemManagement from './components/ItemManagement';
import AlloyCalculator from './components/AlloyCalculator';
import Footer from './components/Footer';
import './App.css';

function App() {
  useEffect(() => {
    const checkTheme = () => {
      const userModule = localStorage.getItem('userModule');
      if (userModule === 'FE') {
        document.body.classList.add('theme-fe');
      } else {
        document.body.classList.remove('theme-fe');
      }
    };

    checkTheme();
    window.addEventListener('storage', checkTheme);
    const interval = setInterval(checkTheme, 500);

    return () => {
      window.removeEventListener('storage', checkTheme);
      clearInterval(interval);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/superadmin-dashboard" element={<SuperadminDashboard />} />
          <Route path="/superadmin/companies" element={<CompanyManagement />} />
          <Route path="/superadmin/admins" element={<AdminUserManagement />} />
          <Route path="/superadmin/users" element={<AdminUserManagement />} />
          <Route path="/superadmin/subscription-plans" element={<SubscriptionPlanManagement />} />
          <Route path="/superadmin/subscriptions/company/:companyId" element={<CompanySubscriptionDetails />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUserManagement />} />
          <Route path="/admin/subscription" element={<CompanySubscriptionDetails />} />
          <Route path="/admin/subscriptions/company/:companyId" element={<CompanySubscriptionDetails />} />
          <Route path="/select-module" element={<ModuleSelection />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/item-management" element={<ItemManagement />} />
          <Route path="/alloy-calculator" element={<AlloyCalculator />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
